import isNil from 'lodash/isNil'

import * as Model from 'api/model'

// Note this is reset on drawer closed... not sure why this is triggered on drawer close.
// Set breakpoint and close drawer to see details. Seems to be somehow related to jQuery.
export default function () {
  const el = document.getElementsByClassName('pozi-drawer-tabs-panel-wrapper')
  if (isNil(el) || isNil(el[0])) {
    return
  }
  el[0].addEventListener('scroll', function (evt) {
    const activetabid = Model.get('app.drawer.activetabid', null)
    // Only implements for layers for now.
    if (isNil(activetabid) || activetabid !== 'layers') {
      return
    }
    const scrollTop = el[0].scrollTop || 0
    // console.log('>>> set scroll position for', activetabid, scrollTop)
    Model.set('app.drawer.activetabidscrollposition[' + activetabid + ']', scrollTop)
  })
}

export function setScrollPosition (activetabid) {
  window.setTimeout(function () {
    const scrollTop = Model.get('app.drawer.activetabidscrollposition[' + activetabid + ']', null)
    // console.log('<<< get scroll position for', activetabid, scrollTop)
    if (isNil(scrollTop)) {
      return
    }
    const el = document.getElementsByClassName('pozi-drawer-tabs-panel-wrapper')
    if (isNil(el) || isNil(el[0]) || isNil(el[0].scrollTop)) {
      return
    }
    el[0].scrollTop = scrollTop
  }, 50)
}
